module.exports = "<div class=\"icon-stage theme-{{ theme }}\"> <i class=icon-box :class=\"[typeClass, nameClass, sizeClass]\"></i> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/common/components/base/icon/icon.tpl
// module id = 940
// module chunks = 2